export class NumberUtils {

  public static LPad(value: string, padding: number, fill = '0') {
    return (value.length >= padding) ? value : (new Array(padding).join(fill) + value).slice(-padding);
  }

  public static FormatToDecimal(value: string | number, decimalRule = '0-99', thousandSeparator = ',', decimalSeparator = '.') {
    if (typeof value !== 'undefined' && value !== null) {
      value = NumberUtils.FormatCommasInNumbers(value);
    }
    // Rounding Decimal Places
    const parsedRule = decimalRule.split('-');
    const minDecimals = parseInt(parsedRule[0], 10);
    const maxDecimals = parseInt(parsedRule[1], 10);

    if (!RegExp('(^[0-99])-([0-99]$)').test(decimalRule) || isNaN(minDecimals) || isNaN(maxDecimals)) {
      throw Error('Invalid decimal rule');
    }

    const adjustment = NumberUtils.decimalAdjust('round', NumberUtils.RemoveFormatting(value), -maxDecimals);
    const [wholeNumber, remainder] = `${adjustment}`.split('.');
    // Formatting whole numbers
    const isNegative = wholeNumber.includes('-');
    const wholeFormattedNumber = wholeNumber
      .replace('-', '')
      .split('')
      .reverse()
      .map((a: string, i: number) => {
        return `${a}${i !== 0 && i % 3 === 0 && ((!isNegative && wholeNumber.length > 3) || (isNegative && wholeNumber.length > 4))
            ? thousandSeparator
            : ''
          }`;
      })
      .reverse()
      .join('');

    if (isNaN(+adjustment)) {
      return value;
    }

    return `${isNegative ? '-' : ''}${wholeFormattedNumber}${maxDecimals !== 0 && (minDecimals !== 0 || remainder) ? decimalSeparator : ''
      }${remainder ? remainder : ''}${minDecimals > 0 ? '0'.repeat(minDecimals - (remainder ? remainder.length : 0)) : ''
      }`;
  }

  public static RemoveFormatting(value: string | number): number {
    const valArr = `${value}`.replace(',', '.')?.split('');
    const valFiltered = valArr?.filter((x) => x !== ' ');
    const valProcessed = valFiltered?.join('');
    return parseFloat(valProcessed);
  }

  // see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor
  private static decimalAdjust(type: string, value: any, exp: number) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return (Math as any)[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = (Math as any)[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  private static FormatCommasInNumbers(value: any): string {
    if (value.toString().trim() === '' || isNaN(value.toString().replace(/,/g, ''))) {
      return value;
    }
    const decArr = `${value}`.replace(/ /g, '').split('.');
    const valArr = decArr[0].split(',');
    const negativeConstraint = valArr.includes('-0') ? '-' : '';
    let itemCount = valArr.length;
    let outValue = 0;
    if (valArr.length > 1) {
      valArr.forEach((item) => {
        outValue +=
          itemCount > 1
            ? parseInt(item === '' ? '0' : item, 10) * Math.pow(1000, itemCount - 1)
            : parseFloat(item === '' ? '0' : '0.' + item) * 1000;
        itemCount--;
      });
    } else {
      outValue = parseInt(valArr[0], 10);
    }
    if (decArr.length === 1) {
      decArr.push('0');
    }
    return negativeConstraint + outValue + ',' + decArr[1];
  }
}
